import { TWO_PI } from "./core";

/**
 * Clean an angle to be within the range of 0 to some number of radians (the quotient).
 * Defaults to a quotient of 2 * PI (360 degrees).
 * @note the standard ANGLE_EPSILON is generally too small for this function.
 */
export function angleClean(angle: number, quotient = TWO_PI, tolerance = 0.00001): number {
  if (quotient < tolerance) {
    return angle;
  }

  let remainder = angle / quotient;
  const rounded = Math.round(remainder);
  if (Math.abs(rounded - remainder) < tolerance) {
    remainder = rounded;
  }
  if (remainder >= 1 - tolerance) {
    return angle - Math.floor(remainder) * quotient;
  }
  if (remainder <= -1 + tolerance) {
    return angle - Math.ceil(remainder) * quotient;
  }
  return angle;
}
